module.exports = __webpack_public_path__ + "static/media/checklist-header-bg.158fa40a.svg";